export enum BookEventSlotStep {
  CHOOSE_TICKET_CATEGORY = 'CHOOSE_TICKET_CATEGORY',
  CHOOSE_SLOT = 'CHOOSE_SLOT',
  PERSONAL_DATA = 'PERSONAL_DATA',
  TICKETS_DATA = 'TICKETS_DATA',
  PAYMENT = 'PAYMENT',
}

export namespace BookEventSlotStep {
  export function getAll(): BookEventSlotStep[] {
    return [
      BookEventSlotStep.CHOOSE_TICKET_CATEGORY,
      BookEventSlotStep.CHOOSE_SLOT,
      BookEventSlotStep.PERSONAL_DATA,
      BookEventSlotStep.TICKETS_DATA,
      BookEventSlotStep.PAYMENT,
    ];
  }
}
